import { useQuery } from '@tanstack/react-query';

import { getPackagePrice } from '../queries';
import { proConst } from '..';

export const useProPackagePrice = () => {
  const { data, ...args } = useQuery({
    queryKey: [proConst.queryKeys.PACKAGE_PRICE],
    queryFn: getPackagePrice
  });

  return { ...data, ...args };
};
